<template>
	<div class="modal-backdrop">
		<div class="modal">
			<div class="modal-header">
				<h5 :style="{ color: titleColor }">{{ title }}</h5>
				<h5 v-if="title2 !== ''" :style="{ color: titleColor }">
					{{ title2 }}
				</h5>
			</div>
			<div class="modal-content">
				<div>{{ text1 }}</div>
				<div v-if="text2 !== ''">{{ text2 }}</div>
				<div v-if="text3 !== ''">{{ text3 }}</div>
				<div v-if="textHtml !== ''" v-html="textHtml"></div>
			</div>
			<template v-if="multiBtn">
				<div class="modal-footer">
					<VrpMainButton
						v-if="props.leftBtnEnable"
						v-bind="leftButtonProps"
						class="cancel-btn"
						@click="handleLeftBtnClick($event)"
					/>
					<VrpMainButton
						v-if="props.rightBtnEnable"
						v-bind="rightButtonProps"
						class="confirm-btn"
						@click="handleRightBtnClick($event)"
					/>
				</div>
			</template>
			<template v-else>
				<div class="modal-footer">
					<VrpMainButton
						v-if="props.rightBtnEnable"
						v-bind="rightButtonProps"
						class="cancel-btn"
						@click="handleRightBtnClick($event)"
					/>
				</div>
			</template>
		</div>
	</div>
</template>
<script setup>
import VrpMainButton from '@vrp/components/common/VrpMainButton.vue';
import { useStore } from '@/vrp/store';
import { inject } from 'vue';
const store = inject('store');
// const store = useStore();
const props = defineProps({
	title: {
		type: String,
		required: true,
		default: '',
	},
	title2: {
		type: String,
		default: '',
	},
	text1: {
		type: String,
		default: '',
	},
	text2: {
		type: String,
		default: '',
	},
	text3: {
		type: String,
		default: '',
	},
	textHtml: {
		type: String,
		default: '',
	},
	leftBtnText: {
		type: String,
		default: '',
	},
	rightBtnText: {
		type: String,
		default: '',
	},
	titleColor: {
		type: String,
		default: '#000', // 기본값 검정색
	},
	state: {
		type: String,
		required: false,
		default: 'common_alert_modal_state',
	},
	leftBtnEnable: {
		type: Boolean,
		default: true,
	},
	rightBtnEnable: {
		type: Boolean,
		default: true,
	},
	leftBtnWidth: {
		type: String,
		default: '160px',
	},
	leftBtnHeight: {
		type: String,
		default: '40px',
	},
	rightBtnWidth: {
		type: String,
		default: '160px',
	},
	rightBtnHeight: {
		type: String,
		default: '40px',
	},
	multiBtn: {
		type: Boolean,
		default: true,
	},
});
const leftButtonProps = {
	text: props.leftBtnText,
	colors: {
		enabled: '#FFF',
		disabled: '#F5F5F5',
		hover: '#F5F5F5',
		textEnabled: '#000',
		textDisabled: '#B8B8B8',
	},
	imageUrl: '',
	disabledImageUrl: '',
	width: props.leftBtnWidth,
	height: props.leftBtnHeight,
	fontSize: '16px',
	padding: '10px 10px',
	iconWidth: '',
	iconHeight: '',
	enableBorder: '1px solid var(--common_black_disable, #B8B8B8)',
	disableBorder: '1px solid var(--common_black_disable, #B8B8B8)',
};
const rightButtonProps = {
	text: props.rightBtnText,
	colors: {
		enabled: '#4189eb',
		disabled: '#F5F5F5',
		hover: '#3C7ED9',
		textEnabled: '#FFF',
		textDisabled: '#B8B8B8',
	},
	imageUrl: '',
	disabledImageUrl: '',
	width: props.rightBtnWidth,
	height: props.rightBtnHeight,
	fontSize: '16px',
	padding: '10px 10px',
	iconWidth: '',
	iconHeight: '',
	enableBorder: 'none',
	disableBorder: '1px solid var(--common_black_disable, #B8B8B8)',
};

const emit = defineEmits(['rightClick', 'leftClick', 'regClick']);

const handleLeftBtnClick = event => {
	emit('leftClick', event);
	store.changeModalState('alertModal', props.state, false);
	store.change_modal_state(props.state, false);
};

const handleRightBtnClick = event => {
	emit('rightClick', event);
	store.changeModalState('alertModal', props.state, false);
	store.change_modal_state(props.state, false);
};
</script>
<style scoped>
.modal-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: var(--z-modal-child-back);
	font-family: 'Noto Sans KR';
}
.modal {
	display: flex;
	width: 510px;
	height: 210x;
	padding: 30px 15px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 24px;
	border-radius: 8px;
	background: var(--common_white, #fff);
	transition: opacity 0.3s ease;
	z-index: var(--z-modal_child);
}
.modal-header {
	display: flex;
	flex-direction: column;
	gap: 10px;
}
h5 {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	font-weight: 700;
}
.modal-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	gap: 4px;
}

.close-btn {
	display: flex;
	flex-basis: 24px;
	font-weight: 700;
	border: none;
	background: none;
	font-size: 24px;
	cursor: pointer;
}
.modal-footer {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 22px;
}
</style>
